import React from 'react';
import factory from 'components/Icons/factory';

export const Flipboard = factory(
  'Flipboard',
  <path d="M123 44.3H83.7v39.4H44.3V123H5V5h118z" />
);

export default Flipboard;
